import { jsx } from '@emotion/react';
export const parseAnnouncementBody = (message, options = {}) => {
    const bodyComponents = {
        Bold: ({ children }) => {
            return (jsx("span", { css: {
                    fontWeight: 'bold',
                } }, children));
        },
        Link: ({ children, href }) => {
            return (jsx("a", { href: href, target: "_blank", onClick: (e) => e.stopPropagation(), rel: "noreferrer", css: {
                    color: '#1D0063',
                    fontWeight: '800',
                } }, children));
        },
        Container: ({ children }) => {
            return (jsx("div", { css: {
                    whiteSpace: 'pre-wrap',
                } }, children));
        },
        ...options.components,
    };
    const text = message.caption || message.text || '';
    const entities = message.caption_entities || message.entities || [];
    if (options.raw) {
        return text;
    }
    const parsedText = entities.length ? [] : [text];
    let lastIndex = 0;
    for (const entity of entities) {
        parsedText.push(text.slice(lastIndex, entity.offset));
        const targetStr = text.slice(entity.offset, entity.offset + entity.length);
        if (entity.type === 'bold') {
            parsedText.push(jsx(bodyComponents.Bold, null, targetStr));
        }
        else if (entity.type === 'url') {
            parsedText.push(jsx(bodyComponents.Link, { href: targetStr }, targetStr));
        }
        else if (entity.type === 'text_link') {
            parsedText.push(jsx(bodyComponents.Link, { href: entity.url }, targetStr));
        }
        else {
            parsedText.push(targetStr);
        }
        lastIndex = entity.offset + entity.length;
    }
    const tailingStr = text.slice(lastIndex);
    if (tailingStr) {
        parsedText.push(tailingStr);
    }
    return jsx(bodyComponents.Container, null, parsedText);
};
